<template>
  <table>
    <thead>
      <tr>
        <th v-if="showActiveToggle" class="" style="width: 80px">Active</th>
        <th v-for="column in columns" :key="column.field" @click="setSortColumn(column.field)">
          <div class="col-header">
          {{ column.label }}
          <fa
            v-if="column.field === sortColumn"
            class="arrow"
            :class="{ 'fa-rotate-180': sortAscending }"
            :icon="['fad', 'sort-down']"
          />
          <fa
            v-else
            class="arrow"
            :icon="['fad', 'sort']"
          />
          </div>
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="sortedRows.length < 1">
        <td class="text-center" colspan="9001">Nothing to show here.</td>
      </tr>
      <tr v-for="row in sortedRows" :key="row._id || JSON.stringify(row)">
        <td v-if="showActiveToggle" >
          <toggle-button 
            v-model="row.active" 
            :color="{ checked: '#28a745', unchecked: '#b8b8b8' }"
            :sync="true"
            :width="30" 
            :height="20"
            @change="$emit('save', row)"
          />
        </td>
        <td v-for="column in columns" :key="(row._id || JSON.stringify(row)) + column.field">
          <div v-html="stripTags(getRowField(row, column.field))"></div>
          
        </td>
        <td class="text-right">
          <div class="button-wrapper">
            <button v-if="$listeners.edit" class="btn btn-outline-primary btn-sm" @click="$emit('edit', row)">Edit</button>
            <button v-if="$listeners.clone" class="btn btn-outline-primary btn-sm ml-2" @click="$emit('clone', row)">Clone</button>
            <button v-if="$listeners.delete" class="btn btn-outline-danger btn-sm ml-2" @click="$emit('delete', row)">Delete</button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import { sortBy } from 'lodash'
export default {
  props: ['columns', 'rows', 'show-active-toggle'],

  data () {
    return {
      sortAscending: true,
      sortColumn: this.columns[0].field
    }
  },

  computed: {
    sortedRows () {
      if (!this.sortAscending) {
        return sortBy(this.rows, this.sortColumn).reverse()
      } else {
        return sortBy(this.rows, this.sortColumn)
      }
    }
  },

  methods: {
    getRowField (row, field) {
      let fieldPathArray = field.split('.')
      let currentField = row
      fieldPathArray.forEach(field => {
        currentField = currentField[field]
      })
      return currentField
    },

    setSortColumn (field) {
      if (this.sortColumn === field) {
        this.sortAscending = !this.sortAscending
      } else {
        this.sortColumn = field
      }
    },

    stripTags: function (string) {
      if (string && typeof string === 'string') {
        let regex = /<\/?p[^>]*>/g
        return string.replace(regex, '')
      }

      return string
    }
  }
}
</script>
<style lang="scss" scoped>
table {
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #d4d4d4;
  border-radius: 6px;
  // table-layout: fixed;
  width: 100%;

  thead {
    background-color: #e2e8f0;
    border-bottom: 1px solid #cbd5e0;
    font-size: 12px;
    position: sticky;
    text-transform: uppercase;
    top: 0;
    z-index: 10;
  }  

  th {
    cursor: pointer;
  }  

  tbody {
    overflow: auto;
  }

  th, td {
    font-weight: 400;
    padding: 10px 15px;
    user-select: none;
  }

  tr {
    &:nth-child(2n) {
      background-color: #fbfbfb;
    }

    &:hover {
      background-color: rgba(#e2e8f0, 0.5);
    }
  }
}

.col-header {
  align-items: center;
  display: flex;
  position: relative;

  svg {
    margin-left: 6px;
    position: relative;
  }
}

.button-wrapper {
  display: flex;
  justify-content: flex-end;
}
</style>